import { render } from "./MainLoading.vue?vue&type=template&id=7243a136&scoped=true"
const script = {}

import "./MainLoading.vue?vue&type=style&index=0&id=7243a136&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\m.sadati\\projects\\taskban-vue-2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7243a136"]])

export default __exports__